export default __webpack_public_path__ + "0bc2d11ea23aed06e7d645effb68f3a5.png";